const WITHDRAW_API_URL =
  "https://trph5vmvhd.execute-api.us-east-1.amazonaws.com/withdraw-from-contract";

function showFormError(form, message) {
  let errorEl = form.querySelector(".withdraw-error");
  if (!errorEl) {
    errorEl = document.createElement("div");
    errorEl.className = "withdraw-error errors";
    form.prepend(errorEl);
  }
  errorEl.textContent = message;
  errorEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
}

function clearFormError(form) {
  form.querySelector(".withdraw-error")?.remove();
}

function onloadTurnstile() {
  turnstile.render("#turnstile-container", {
    sitekey: "0x4AAAAAADtc42fcWoT3D9-L",
    callback: function (token) {
      document.getElementById("cf-turnstile-response").value = token;
    },
  });
}

async function submitWithdrawForm(form) {
  clearFormError(form);

  const formData = new FormData(form);
  const name = formData.get("contact[name]")?.trim();
  const email = formData.get("contact[email]")?.trim();
  const orderNumber = formData.get("contact[order_number]")?.trim();
  const token = document.getElementById("cf-turnstile-response").value;

  if (!name) {
    showFormError(form, "Please enter your name.");
    return;
  }
  if (!email) {
    showFormError(form, "Please enter your email address.");
    return;
  }
  if (!orderNumber) {
    showFormError(form, "Please enter your order number.");
    return;
  }
  if (!token) {
    showFormError(form, "Please complete the security check.");
    return;
  }

  const submitBtn = form.querySelector("button[type=submit]");
  const loader = form.querySelector(".withdraw-loader");
  submitBtn.disabled = true;
  loader.style.display = "inline-block";

  try {
    const response = await fetch(WITHDRAW_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, orderNumber, token }),
    });

    const data = await response.json();
    console.log("Withdraw API response:", response.status, data);

    if (!response.ok || data.error) {
      if (data.error === "Invalid Turnstile") {
        showFormError(
          form,
          "Security check failed. Please complete the challenge again.",
        );
        turnstile.reset("#turnstile-container");
        document.getElementById("cf-turnstile-response").value = "";
      } else {
        showFormError(
          form,
          data.error || "An error occurred. Please try again.",
        );
      }
      submitBtn.disabled = false;
      loader.style.display = "none";
      return;
    }

    document.querySelector("#success-message").style.display = "flex";
    form.style.display = "none";
  } catch (err) {
    console.error("Withdraw form error:", err);
    showFormError(form, "An error occurred. Please try again.");
    submitBtn.disabled = false;
    loader.style.display = "none";
    turnstile.reset("#turnstile-container");
    document.getElementById("cf-turnstile-response").value = "";
  }
}

document.querySelector(".account-form form")?.addEventListener(
  "submit",
  function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitWithdrawForm(e.currentTarget);
  },
  { capture: true },
);

if (typeof turnstile !== "undefined") {
  onloadTurnstile();
} else {
  window.onloadTurnstile = onloadTurnstile;
}
